export const locales = [
  'en-US',
  'zh-TW',
  'ja-JP',
  'hi-IN',
  'es-ES',
  'de-DE',
  'fr-FR',
  'pt-BR',
  'it-IT',
  'ru-RU',
  'nl-NL',
  'pl-PL',
] as const

export type Locale = (typeof locales)[number]

export const DEFAULT_LOCALE: Locale = 'en-US'
export const LANG_CODE_COOKIE_DOMAIN = '.viverse.com'
